<script>
// Components
import Layout from "@/router/layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config.json";
import SlGroupStats from "@/router/views/finance/slgroup-stats"

// Helpers
import {authComputed} from "@/state/helpers";
import DateUtils from '@/helpers/date';
import FinanceUtils from '@/helpers/finance';

// Services
import FinanceDataService from "@/services/FinanceDataService";
import MarketingDataService from "@/services/MarketingDataService"

// External Components
import DatePicker  from "vue2-datepicker";
import 'vue2-datepicker/index.css';
import {VueTabs, VTab} from 'vue-nav-tabs'
import 'vue-nav-tabs/themes/vue-tabs.css';

// Lib
import isEmpty from "is-empty";

const ads = {};
const marketing = {};
const organic = {};
const adsData1 = {};
const adsData2 = {};

export default {
  name: "slGroups",
  page: {
    localePicker: () => import(`vue2-datepicker/locale/${this.$i18n.locale}`),
    title: "Finance SLGroups Stats",
    meta: [
      {
        name: "description",
        content: appConfig.description
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    DatePicker,
    VueTabs,
    VTab,
    SlGroupStats,
  },
  methods: {
    ...DateUtils,
    ...FinanceUtils,

    handleDateChange() {
      let now = new this.$moment();
      switch(this.filters.dates.selected) {
        case "always":
          this.filters.fromDate = new this.$moment('2021-01-01').format('YYYY-MM-DD');
          this.filters.toDate = now.format('YYYY-MM-DD');
          break;
        case "week":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(1, 'week').startOf('day').format('YYYY-MM-DD');
          break;
        case "curMonth":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('month').format('YYYY-MM-DD');
          break;
        case "last30Day":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(30, 'day').startOf('day').format('YYYY-MM-DD');
          break;
        case "lastMonth":
          this.filters.fromDate = now.subtract(1, 'month').startOf('month').format('YYYY-MM-DD');
          this.filters.toDate = now.endOf('month').format('YYYY-MM-DD');
          break;
        case "last3Month":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.subtract(3, 'month').startOf('day').format('YYYY-MM-DD');
          break;
        case "curYear":
          this.filters.toDate = now.format('YYYY-MM-DD');
          this.filters.fromDate = now.startOf('year').format('YYYY-MM-DD');
          break;
        case "custom":
          this.filters.fromDate = null;
          this.filters.toDate = null;
          break;
      }
    },

    getRequestParamsOldStats() {
      const params = {};

      params['old'] = true;
      params['subscription'] = this.filtersOld.subscriptions.selected;
      params['paymentMethod'] = this.filtersOld.paymentMethod.selected;
      params['paymentProcessor'] = this.filtersOld.paymentProcessor.selected;
      params['countries'] = this.filtersOld.countries.selected;
      params['organic'] = this.filtersOld.organic.selected;
      if (this.filtersOld.adsData3.selected !== 'all') {
        params['ads'] = this.filtersOld.adsData3.selected;
      }
      else if (this.filtersOld.adsData2.selected !== 'all') {
        params['ads'] = this.filtersOld.adsData2.selected;
      }
      else if (this.filtersOld.adsData1.selected !== 'all') {
        params['ads'] = this.filtersOld.adsData1.selected;
      }
      else {
        params['ads'] = this.filtersOld.ads.selected;
      }

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getRequestParamsStats() {
      const params = {};
      params['old'] = false;
      if (this.filters.dates.selected === 'custom' && this.filters.dates.dateRange !== null) {
        this.filters.fromDate = this.$moment(this.filters.dates.dateRange[0]).format("YYYY-MM-DD 00:00:00");
        this.filters.toDate = this.$moment(this.filters.dates.dateRange[1]).format("YYYY-MM-DD 23:59:59");
      }
      else if (this.filters.fromDate === null)
        this.handleDateChange();

      if (this.filters.toDate !== null)
        params['toDate'] = this.filters.toDate;

      if (this.filters.fromDate !== null)
        params['fromDate'] = this.filters.fromDate;

      params['subscription'] = this.filters.subscriptions.selected;
      params['paymentMethod'] = this.filters.paymentMethod.selected;
      params['paymentProcessor'] = this.filters.paymentProcessor.selected;
      params['countries'] = this.filters.countries.selected;
      params['organic'] = this.filters.organic.selected;
      if (this.filters.adsData3.selected !== 'all') {
        params['ads'] = this.filters.adsData3.selected;
      }
      else if (this.filters.adsData2.selected !== 'all') {
        params['ads'] = this.filters.adsData2.selected;
      }
      else if (this.filters.adsData1.selected !== 'all') {
        params['ads'] = this.filters.adsData1.selected;
      }
      else {
        params['ads'] = this.filters.ads.selected;
      }

      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getRequestParamsPoolStats(pool) {
      const params = {};
      params['pool'] = JSON.stringify(pool);
      if (this.$store.state.layout.timezone === 'utc') {
        params['tz'] = this.$moment.tz.guess();
      }

      return params;
    },

    getDateFromTimestamp(obj, format) {
      if (obj === null)
        return "-";

      return DateUtils.formatDateTimestamp(obj._seconds, format);
    },

    getFilters() {
      MarketingDataService.getAdsNonOrganicFilters()
          .then(response => {
            marketing.ads = response.data.filters.ads;
            response.data.filters.ads.forEach(ad => {
              this.filters.ads.options.push(ad);
              this.filtersOld.ads.options.push(ad);
            });
          })
          .catch(error => {
            window.console.log(error);
            this.$toast.error(this.$t("marketing.getAdsNonOrganicFilters"));
          });
    },

    loadPools() {
      this.loadedPools = true;
      this.isLoadingPools = true;

      FinanceDataService.getSlGroupsPools()
          .then(response => {
            this.poolsEnabled = response.data.poolsEnabled;
            this.poolsDisabled = response.data.poolsDisabled;
            this.isLoadingPools = false;
          })
          .catch (error => {
            window.console.error(error);
            this.$toast.error(this.$t("finance.errorTransactionsNoResult"));
            this.isLoadingPools = false;
          });
    },

    loadOldStats() {
      this.isLoadingOld = true;
      this.loadedOldStats = true;
      const params = this.getRequestParamsOldStats();

      FinanceDataService
          .getSlGroupsStats(params)
          .then(response => {
            const { stats } = response.data;
            this.statsOld = stats;
            this.isLoadingOld = false;
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("finance.errorTransactionsNoResult"));
            this.isLoadingOld = false;
          });
    },

    loadStats() {
      this.isLoading = true;
      this.loadedStats = true;
      const params = this.getRequestParamsStats();

      FinanceDataService
          .getSlGroupsStats(params)
          .then(response => {
            const { stats } = response.data;
            this.statsAll = stats;
            this.checkRelevantsGroups();
            this.isLoading = false;
          })
          .catch(error => {
            window.console.error(error);
            this.$toast.error(this.$t("finance.errorTransactionsNoResult"));
            this.isLoading = false;
          });
    },

    checkRelevantsGroups() {
      this.stats = [];
      this.statsAll.forEach(stat => {
        if (!this.filters.onlyRelevant || stat.leads > 0) {
          this.stats.push(stat);
        }
      });
    },

    processFiltersOldStats() {
      this.loadOldStats();
    },

    processFiltersStats() {
      this.loadStats();
    },

    /* groups stats pane */

    openPoolPane() {
      if (!this.isPoolStatsDisplayed)
        this.isPoolStatsDisplayed = true;
    },

    closePoolPane() {
      this.poolGroupsActive = '';
      this.isPoolStatsDisplayed = false;
    },

    async showPoolStats(pool) {
      const isStatsAlreadyDisplayed = this.poolGroupsTabs.findIndex(x => x.id === pool.id);
      let forceShow = false;
      if (isStatsAlreadyDisplayed === -1) {
        try {
          const params = this.getRequestParamsPoolStats(pool);
          const result = await FinanceDataService.getSlGroupsPoolStats(params)
          if (typeof result.data === 'undefined' || typeof result.data.result === "undefined")
            throw new Error('unable to find pool '+pool.id);

          this.poolGroupsTabs.push(result.data.result);
          forceShow = true;
        }
        catch (error) {
          window.console.error(error);
          this.$toast.error(this.$t("global_error"));
        }
      }

      this.openPoolPane();

      if (forceShow || (!forceShow && this.poolGroupsActive !== pool.id)) {
        this.poolGroupsActive = '';
        setTimeout(() => { this.poolGroupsActive = pool.id; }, 100);
      }
    },

    removePoolTab(poolId) {
      const index = this.poolGroupsTabs.findIndex(x => x.id === poolId);
      if (index > -1)
        this.poolGroupsTabs.splice(index, 1);

      if (this.poolGroupsTabs.length === 0)
        this.closePoolPane();
    }
  },
  mounted() {
    this.getFilters();
    if (this.tabIndex === 0)
      this.loadStats();
    else if (this.tabIndex === 1)
      this.loadPools();
    else
      this.loadOldStats();
  },
  computed: {
    ...authComputed
  },
  watch: {
    tabIndex: function() {
      if (this.tabIndex === 0 && !this.loadedStats) {
        this.closePoolPane();
        this.loadStats();
      } else if (this.tabIndex === 1 && !this.loadedPools) {
        this.loadPools();
      } else if (this.tabIndex === 2 && !this.loadedOldStats) {
        this.closePoolPane();
        this.loadOldStats();
      }
    },

    "filters.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filters.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filters.ads.selected = 'all';
        this.filters.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filters.ads.options.push(ad);
          });
        }
      }
    },
    "filters.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData1.selected = 'all';
      this.filters.adsData2.selected = 'all';
      this.filters.adsData3.selected = 'all';
      this.filters.adsData1.options = [{
        value: 'all', text: 'All Data1'
      }];
      this.filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(ads[newVal])) {
        MarketingDataService.getAdsNonOrganicData1Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData1.options.push(ad);
              });

              ads[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData1Filters"));
            });
      }
      else {
        ads[newVal].forEach(ad => {
          this.filters.adsData1.options.push(ad);
        });
      }
    },
    "filters.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData2.selected = 'all';
      this.filters.adsData3.selected = 'all';
      this.filters.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData1[newVal])) {
        MarketingDataService.getAdsNonOrganicData2Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData2.options.push(ad);
              });

              adsData1[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData2Filters"));
            });
      }
      else {
        adsData1[newVal].forEach(ad => {
          this.filters.adsData2.options.push(ad);
        });
      }
    },
    "filters.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filters.adsData3.selected = 'all';
      this.filters.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData2[newVal])) {
        MarketingDataService.getAdsNonOrganicData3Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filters.adsData3.options.push(ad);
              });

              adsData2[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData3Filters"));
            });
      }
      else {
        adsData2[newVal].forEach(ad => {
          this.filters.adsData3.options.push(ad);
        });
      }
    },

    "filtersOld.organic.selected": function (newVal, oldVal) {
      if (oldVal === newVal)
        return;

      if (newVal === "organic") {
        this.filtersOld.ads.selected = 'all';
        this.filtersOld.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (isEmpty(organic)) {
          MarketingDataService.getAdsOrganicFilters()
              .then(response => {
                response.data.filters.ads.forEach(ad => {
                  this.filtersOld.ads.options.push(ad);
                });

                organic.ads = response.data.filters.ads;
              })
              .catch(error => {
                window.console.log(error);
                this.$toast.error(this.$t("marketing.getAdsOrganicFilters"));
              });
        }
        else {
          organic.ads.forEach(ad => {
            this.filtersOld.ads.options.push(ad);
          });
        }
      }
      else if (['marketing', 'all'].includes(newVal) && oldVal === "organic") {
        this.filtersOld.ads.selected = 'all';
        this.filtersOld.ads.options = [{
          value: 'all', text: 'All Ads'
        }];
        if (!isEmpty(marketing)) {
          marketing.ads.forEach(ad => {
            this.filtersOld.ads.options.push(ad);
          });
        }
      }
    },
    "filtersOld.ads.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filtersOld.adsData1.selected = 'all';
      this.filtersOld.adsData2.selected = 'all';
      this.filtersOld.adsData3.selected = 'all';
      this.filtersOld.adsData1.options = [{
        value: 'all', text: 'All Data1'
      }];
      this.filtersOld.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filtersOld.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(ads[newVal])) {
        MarketingDataService.getAdsNonOrganicData1Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filtersOld.adsData1.options.push(ad);
              });

              ads[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData1Filters"));
            });
      }
      else {
        ads[newVal].forEach(ad => {
          this.filtersOld.adsData1.options.push(ad);
        });
      }
    },
    "filtersOld.adsData1.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filtersOld.adsData2.selected = 'all';
      this.filtersOld.adsData3.selected = 'all';
      this.filtersOld.adsData2.options = [{
        value: 'all', text: 'All Data2'
      }];
      this.filtersOld.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData1[newVal])) {
        MarketingDataService.getAdsNonOrganicData2Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filtersOld.adsData2.options.push(ad);
              });

              adsData1[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData2Filters"));
            });
      }
      else {
        adsData1[newVal].forEach(ad => {
          this.filtersOld.adsData2.options.push(ad);
        });
      }
    },
    "filtersOld.adsData2.selected": function (newVal, oldVal) {
      if (oldVal === newVal || newVal === 'all')
        return;

      this.filtersOld.adsData3.selected = 'all';
      this.filtersOld.adsData3.options = [{
        value: 'all', text: 'All Data3'
      }];

      if (isEmpty(adsData2[newVal])) {
        MarketingDataService.getAdsNonOrganicData3Filters(newVal)
            .then(response => {
              response.data.filters.ads.forEach(ad => {
                this.filtersOld.adsData3.options.push(ad);
              });

              adsData2[newVal] = response.data.filters.ads;
            })
            .catch(error => {
              window.console.log(error);
              this.$toast.error(this.$t("marketing.getAdsNonOrganicData3Filters"));
            });
      }
      else {
        adsData2[newVal].forEach(ad => {
          this.filtersOld.adsData3.options.push(ad);
        });
      }
    }
  },
  data() {
    return {
      tabIndex:0,
      isPoolStatsDisplayed: false,

      isLoading: false,
      isLoadingOld: false,
      isLoadingPools: false,

      loadedStats: false,
      loadedOldStats: false,
      loadedPools: false,

      title: this.$t("menuitems.finance.slGroups"),

      stats: [],
      statsAll: [],
      statsOld: [],

      poolsEnabled: [],
      poolsDisabled: [],

      filters: {
        onlyRelevant: true,
        fromDate: null,
        toDate: null,
        dates: {
          dateRange: null,
          selected: 'last3Month',
          options: [
            {value:'week', text:this.$t("dates.week")},
            {value:'curMonth', text:this.$t("dates.curMonth")},
            {value:'last30Day', text:this.$t("dates.last30Day")},
            {value:'lastMonth', text:this.$t("dates.lastMonth")},
            {value:'last3Month', text:this.$t("dates.last3Month")},
            {value:'curYear', text:this.$t("dates.curYear")},
            {value:'always', text:this.$t("dates.always")},
            {value:'custom', text:this.$t("dates.custom")}
          ]
        },
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        paymentMethod: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.method_all")},
            {value: 'C', text: this.$t("finance.method_card")},
            {value: 'S', text: this.$t("finance.method_store")},
          ]
        },
        paymentProcessor: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.processor_all")},
            {value: 'payplug', text: this.$t("finance.processor_payplug")},
            {value: 'stripe', text: this.$t("finance.processor_stripe")},
            {value: 'hipay', text: this.$t("finance.processor_hipay")},
            {value: '', text: '--------------'},
            {value: 'GP', text: this.$t("finance.processor_google")},
            {value: 'AP', text: this.$t("finance.processor_apple")},
          ]
        },
        subscriptions: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.subscriptions_all")},
            {value: 'sub_1_week', text: this.$t("finance.sub_1_week")},
            {value: 'sub_1_month', text: this.$t("finance.sub_1_month")},
            {value: 'sub_3_month', text: this.$t("finance.sub_3_month")},
            {value: 'sub_6_month', text: this.$t("finance.sub_6_month")},
            {value: '', text: '---------'},
            {value: 'sub_12_month', text: this.$t("finance.sub_12_month")},
            {value: 'sub_lifetime', text: this.$t("finance.sub_lifetime")},
            {value: 'sub_1_month_ft3d', text: this.$t("finance.sub_1_month_ft3d")},
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        pools: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Pools'
          }]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
      },
      filtersOld: {
        countries: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Countries'},
            {value: '', text: '----------------'},
            {value: 'FR', text: 'FR - France'},
            {value: 'BE', text: 'BE - Belgium'},
            {value: 'CH', text: 'CH - Switzerland'},
            {value: 'CA', text: 'CA - Canada'},
            {value: '', text: '----------------'},
            {value: 'others', text: 'Others'},
          ]
        },
        paymentMethod: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.method_all")},
            {value: 'C', text: this.$t("finance.method_card")},
            {value: 'S', text: this.$t("finance.method_store")},
          ]
        },
        paymentProcessor: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.processor_all")},
            {value: 'payplug', text: this.$t("finance.processor_payplug")},
            {value: 'stripe', text: this.$t("finance.processor_stripe")},
            {value: 'hipay', text: this.$t("finance.processor_hipay")},
            {value: '', text: '--------------'},
            {value: 'GP', text: this.$t("finance.processor_google")},
            {value: 'AP', text: this.$t("finance.processor_apple")},
          ]
        },
        subscriptions: {
          selected: 'all',
          options: [
            {value: 'all', text: this.$t("finance.subscriptions_all")},
            {value: 'sub_1_week', text: this.$t("finance.sub_1_week")},
            {value: 'sub_1_month', text: this.$t("finance.sub_1_month")},
            {value: 'sub_3_month', text: this.$t("finance.sub_3_month")},
            {value: 'sub_6_month', text: this.$t("finance.sub_6_month")},
            {value: '', text: '---------'},
            {value: 'sub_12_month', text: this.$t("finance.sub_12_month")},
            {value: 'sub_lifetime', text: this.$t("finance.sub_lifetime")},
            {value: 'sub_1_month_ft3d', text: this.$t("finance.sub_1_month_ft3d")},
          ]
        },
        organic: {
          selected: 'all',
          options: [
            {value: 'all', text: 'All Source'},
            {value: 'organic', text: 'Only Organic'},
            {value: 'marketing', text: 'Only Marketing'}
          ]
        },
        ads: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Ads'
          }]
        },
        adsData1: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data1'
          }]
        },
        adsData2: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data2'
          }]
        },
        adsData3: {
          selected: 'all',
          options: [{
            value: 'all', text: 'All Data3'
          }]
        },
      },

      poolGroupsActive: '',
      poolGroupsTabs: []
    }
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" />
    <div class="position-relative">

      <b-button
          class="position-fixed"
          style="top: 77px; right: 15px;z-index:150"
          v-show="!isPoolStatsDisplayed && poolGroupsTabs.length > 0"
          @click="openPoolPane"
          variant="outline-primary">
        <i class="bx bxs-cog"></i> Show Panel
      </b-button>

      <b-tabs content-class="" v-model="tabIndex">

        <!-- stats tab -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> Stats
          </template>
          <div class="card">
            <div class="card-body">
              <!-- Filters -->
              <div class="card">
                <div class="card-body">
                  <!-- filters -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" @submit.stop.prevent>

                    <!-- dates -->
                    <div class="col-sm-auto d-flex">
                      <b-form-select
                          id="slGroupsDatesFilter"
                          @change="handleDateChange"
                          v-model="filters.dates.selected"
                          class="form-select me-lg-1"
                          :options="filters.dates.options">
                      </b-form-select>
                      <date-picker
                          v-show="filters.dates.selected === 'custom'"
                          lang="fr"
                          :placeholder="this.$t('choose_date_interval')"
                          type="date"
                          value-type="format"
                          show-week-number
                          v-model="filters.dates.dateRange"
                          class="me-lg-2"
                          range append-to-body ></date-picker>

                    </div>

                    <!-- Countries -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsCountriesFilter"
                          v-model="filters.countries.selected"
                          class="form-select me-lg-1"
                          :options="filters.countries.options">
                      </b-form-select>
                    </div>

                    <!-- Subscriptions -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsSubFilter"
                          v-model="filters.subscriptions.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filters.subscriptions.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- PaymentMethod -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsMethodFilter"
                          v-model="filters.paymentMethod.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filters.paymentMethod.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- PaymentProcessor -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsProcessorFilter"
                          v-model="filters.paymentProcessor.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filters.paymentProcessor.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- Organic -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsOrganicFilter"
                          v-model="filters.organic.selected"
                          class="form-select me-lg-1"
                          :options="filters.organic.options">
                      </b-form-select>
                    </div>

                    <!-- Ads -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsAdsFilter"
                          v-model="filters.ads.selected"
                          class="form-select me-lg-1"
                          :options="filters.ads.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filters.ads.selected !== 'all'">
                      <b-form-select
                          id="slGroupsAdsData1Filter"
                          v-model="filters.adsData1.selected"
                          class="form-select me-lg-1"
                          :options="filters.adsData1.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filters.adsData1.selected !== 'all'">
                      <b-form-select
                          id="slGroupsAdsData2Filter"
                          v-model="filters.adsData2.selected"
                          class="form-select me-lg-1"
                          :options="filters.adsData2.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filters.adsData2.selected !== 'all'">
                      <b-form-select
                          id="slGroupsAdsData3Filter"
                          v-model="filters.adsData3.selected"
                          class="form-select me-lg-1"
                          :options="filters.adsData3.options">
                      </b-form-select>
                    </div>

                    <!-- relevant -->
                    <div class="col-sm-auto">
                      <b-form-checkbox
                          v-model="filters.onlyRelevant"
                          class="form-check"
                          @change="checkRelevantsGroups"
                      >Hide no results</b-form-checkbox>
                    </div>

                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processFiltersStats">{{ $t("find") }}</b-button>
                    </div>
                  </b-form>
                </div>
              </div>
              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoading"
                    :loading="isLoading"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>
              <!-- empty -->
              <div v-if="!isLoadingOld && stats.length === 0" class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No SLGroups were found for these filters. Try again.</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- results -->
              <div v-if="!isLoadingOld && stats.length > 0" class="row">
                <div
                    v-for="slGroup in stats"
                    :key="slGroup.name"
                    class="col-12 col-lg-3"
                >
                  <SlGroupStats
                      :slGroup="slGroup"
                   />
                </div>
              </div>
            </div>
          </div>
        </b-tab>

        <!-- pools tab -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> Pools
          </template>
          <div class="card">
            <div class="card-body">
              <h4>Active Pools</h4>

              <div v-if="!poolsEnabled && poolsEnabled.length === 0" class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No SLGroups Pools Enabled found.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="!isLoadingPools && poolsEnabled.length > 0">
                <div class="col-12 col-lg-3 col-md-4 col-sm-6" v-for="pool in poolsEnabled" :key="pool.id">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title text-primary">{{ pool.name }}</h4>
                      <small class="font-size-11">#{{ pool.id}}</small>
                      <b-list-group class="mt-1 mb-1" flush>
                        <b-list-group-item class="d-flex justify-content-start align-items-center">
                          <span class="badge bg-info font-size-12 text-light me-1" v-for="group in pool.groups" :key="group">{{ group }}</span>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                          <small class="text-muted">Started At</small>
                          <span class="float-end">{{ getDateFromTimestamp(pool.startedAt, 'YYYY-MM-DD HH:mm') }}</span>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-between align-items-center">
                          <small class="text-muted">Stopped At</small>
                          <span class="float-end">{{ getDateFromTimestamp(pool.stoppedAt, 'YYYY-MM-DD HH:mm') }}</span>
                        </b-list-group-item>
                        <b-list-group-item class="d-flex justify-content-start align-items-center">
                          <span class="badge bg-success font-size-11 text-light me-1" v-if="pool.country !== 'default'">{{ pool.country}}</span>
                          <span class="badge bg-warning font-size-11 text-light me-1" v-if="pool.partner !== 'default'">{{ pool.partner}}</span>
                          <span class="badge bg-light font-size-11 text-dark me-1" v-if="pool.campaign !== 'default'">{{ pool.campaign}}</span>
                        </b-list-group-item>
                      </b-list-group>

                      <b-button @click="showPoolStats(pool)" variant="primary">Stats</b-button>
                    </div>
                  </div>

                </div>
              </div>

              <hr>

              <h4>Disabled Pools</h4>
              <div v-if="!isLoadingPools && poolsDisabled.length === 0" class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No SLGroups Pools disabled found.</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row" v-if="!isLoadingPools && poolsDisabled.length > 0">
              <div class="col-12 col-lg-3 col-md-4 col-sm-6" v-for="pool in poolsDisabled" :key="pool.id">
                <div class="card">
                  <div class="card-body">
                    <h4 class="card-title">{{ pool.name }}</h4>
                    <small class="font-size-11">#{{ pool.id}}</small>
                    <b-list-group class="mt-1 mb-1" flush>
                      <b-list-group-item class="d-flex justify-content-start align-items-center">
                        <span class="badge bg-info font-size-12 text-light me-1" v-for="group in pool.groups" :key="group">{{ group }}</span>
                      </b-list-group-item>
                      <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <small class="text-muted">Started At</small>
                        <span class="float-end">{{ getDateFromTimestamp(pool.startedAt, 'YYYY-MM-DD HH:mm') }}</span>
                      </b-list-group-item>
                      <b-list-group-item class="d-flex justify-content-between align-items-center">
                        <small class="text-muted">Stopped At</small>
                        <span class="float-end">{{ getDateFromTimestamp(pool.stoppedAt, 'YYYY-MM-DD HH:mm') }}</span>
                      </b-list-group-item>
                      <b-list-group-item class="d-flex justify-content-start align-items-center">
                        <span class="badge bg-success font-size-11 text-light me-1" v-if="pool.country !== 'default'">{{ pool.country}}</span>
                        <span class="badge bg-warning font-size-11 text-light me-1" v-if="pool.partner !== 'default'">{{ pool.partner}}</span>
                        <span class="badge bg-light font-size-11 text-dark me-1" v-if="pool.campaign !== 'default'">{{ pool.campaign}}</span>
                      </b-list-group-item>
                    </b-list-group>

                    <b-button @click="showPoolStats(pool)" variant="primary">Stats</b-button>
                  </div>
                </div>

              </div>
            </div>

              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingPools"
                    :loading="isLoadingPools"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>
            </div>


          </div>
        </b-tab>

        <!-- old stats tab -->
        <b-tab>
          <template #title>
            <i class="far fa-user"></i> Old Stats
          </template>
          <div class="card">
            <div class="card-body">
              <!-- Filters -->
              <div class="card">
                <div class="card-body">
                  <!-- filters -->
                  <b-form inline class="row gy-2 gx-3 align-items-center" @submit.stop.prevent>

                    <!-- Countries -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsCountriesFilterOld"
                          v-model="filtersOld.countries.selected"
                          class="form-select me-lg-1"
                          :options="filtersOld.countries.options">
                      </b-form-select>
                    </div>

                    <!-- Subscriptions -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsSubFilterOld"
                          v-model="filtersOld.subscriptions.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filtersOld.subscriptions.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- PaymentMethod -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsMethodFilterOld"
                          v-model="filtersOld.paymentMethod.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filtersOld.paymentMethod.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- PaymentProcessor -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsProcessorFilterOld"
                          v-model="filtersOld.paymentProcessor.selected"
                          class="form-select me-lg-1"
                      >
                        <option v-for="ct in filtersOld.paymentProcessor.options" :key="ct.value" :value="ct.value">{{ ct.text }}</option>
                      </b-form-select>
                    </div>

                    <!-- Organic -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsOrganicFilterOld"
                          v-model="filtersOld.organic.selected"
                          class="form-select me-lg-1"
                          :options="filtersOld.organic.options">
                      </b-form-select>
                    </div>

                    <!-- Ads -->
                    <div class="col-sm-auto">
                      <b-form-select
                          id="slGroupsAdsFilterOld"
                          v-model="filtersOld.ads.selected"
                          class="form-select me-lg-1"
                          :options="filtersOld.ads.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filtersOld.ads.selected !== 'all'">
                      <b-form-select
                          id="slGroupsAdsData1FilterOld"
                          v-model="filtersOld.adsData1.selected"
                          class="form-select me-lg-1"
                          :options="filtersOld.adsData1.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filtersOld.adsData1.selected !== 'all'">
                      <b-form-select
                          id="slGroupsAdsData2FilterOld"
                          v-model="filtersOld.adsData2.selected"
                          class="form-select me-lg-1"
                          :options="filtersOld.adsData2.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto" v-show="filtersOld.adsData2.selected !== 'all'">
                      <b-form-select
                          id="slGroupsAdsData3FilterOld"
                          v-model="filtersOld.adsData3.selected"
                          class="form-select me-lg-1"
                          :options="filtersOld.adsData3.options">
                      </b-form-select>
                    </div>

                    <div class="col-sm-auto">
                      <b-button variant="primary" class="w-md" @click="processFiltersOldStats">{{ $t("find") }}</b-button>
                    </div>
                  </b-form>
                </div>
              </div>
              <!-- Loader -->
              <div class="row d-flex justify-content-center">
                <vue-ellipse-progress
                    v-show="isLoadingOld"
                    :loading="isLoadingOld"
                    :angle="-90"
                    color="#50a5f1"
                    emptyColor="#999"
                    emptyColorFill="#f8f8fb"
                    :size="100"
                    :thickness="3"
                    :emptyThickness="2"
                    lineMode="out 2"
                    animation="bounce 700 400"
                    fontColor="#666"
                    :half="false"
                    class="mt-5 mb-5"
                    fontSize="1rem">
                </vue-ellipse-progress>
              </div>
              <!-- empty -->
              <div v-if="!isLoadingOld && statsOld.length === 0" class="row">
                <div class="col-12">
                  <div class="card">
                    <div class="card-body">
                      <h4 class="card-title">Empty Result</h4>
                      <p>No SLGroups were found for these filters. Try again.</p>
                    </div>
                  </div>
                </div>
              </div>
              <!-- results -->
              <div v-if="!isLoadingOld && statsOld.length > 0" class="row">
                <div
                    v-for="slGroup in statsOld"
                    :key="slGroup.name"
                    class="col-12 col-lg-3"
                >
                  <SlGroupStats
                    :slGroup="slGroup"
                    />
                </div>
              </div>
            </div>
          </div>
        </b-tab>

      </b-tabs>

      <b-sidebar id="sidebar-right" right v-model="isPoolStatsDisplayed">
        <vue-tabs
            v-model="poolGroupsActive"
            active-tab-color="#213213"
            active-text-color="white">
          <v-tab v-for="poolTab in poolGroupsTabs" :key="poolTab.id" :title="poolTab.id" >
            <div slot="title">{{ poolTab.name }} <i @click.stop="removePoolTab(poolTab.id)" class="bx bx-x-circle" ></i></div>
            <div>
              <p class="mt-2 mb-2 font-size-13">
                Started At: {{ getDateFromTimestamp(poolTab.startedAt, 'YYYY-MM-DD HH:mm') }}
              </p>
              <div class="row">
                <div
                    class="col-12"
                    :class="poolTab.groups.length === 2 ? 'col-lg-6' : 'col-lg-3'"
                    v-for="group in poolTab.groups" :key="group.id"
                >
                  <SlGroupStats
                      :slGroup="group"
                  />
                </div>
              </div>
            </div>
          </v-tab>
        </vue-tabs>
      </b-sidebar>

    </div>
  </Layout>
</template>

<style>

.b-sidebar-right {
  width:65%;
}

.b-sidebar-body {
  padding:16px;
}

</style>
